export const PANEL_CLASSES = "bg-white rounded-lg border border-field-outline overflow-hidden flex flex-col";

export const HEADER_CLASSES = "px-3.5 py-2.5 font-semibold text-sm text-off-black border-b border-field-outline bg-very-light-gray flex justify-between items-center";

export const BTN_SM = "text-xs px-2 py-0.5 rounded border border-field-outline text-secondary-gray hover:text-off-black transition-colors";

export const SECTION_LABEL = "text-[11px] font-bold text-medium-gray uppercase tracking-wide mb-2";

export const MAPPING_DISPLAY = "bg-light-green rounded-md px-2.5 py-1 font-mono text-xs text-dark-green flex items-center gap-1.5 flex-1 min-h-[28px]";

export const DROP_ZONE = "flex-1 border-2 border-dashed rounded-md px-3 py-1.5 min-h-[28px] text-xs text-center transition-all";

export const DROP_ZONE_ACTIVE = "border-dark-green bg-light-green text-dark-green";

export const DROP_ZONE_IDLE = "border-field-outline text-medium-gray";

export const LOCKED_FIELD = "bg-very-light-gray rounded-md px-2.5 py-1 font-mono text-xs text-medium-gray flex items-center gap-1.5 flex-1 min-h-[28px] border border-field-outline";
